/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_HealthInputs */

const en_us2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any yes answer makes the plan start more conservatively.`)
};

const pt_br2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer resposta positiva faz o plano começar de forma mais conservadora.`)
};

const es_419_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier respuesta afirmativa hace que el plan empiece de forma más conservadora.`)
};

const pt_pt2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer resposta positiva faz o plano começar de forma mais conservadora.`)
};

const fr_fr2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une seule réponse « oui » suffit pour que le programme démarre plus prudemment.`)
};

const de_de2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes Ja lässt den Plan vorsichtiger beginnen.`)
};

const it_it2_profile_why_health = /** @type {(inputs: Profile_Why_HealthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualsiasi risposta sì fa partire la scheda in modo più prudente.`)
};

/**
* | output |
* | --- |
* | "Any yes answer makes the plan start more conservatively." |
*
* @param {Profile_Why_HealthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_health = /** @type {((inputs?: Profile_Why_HealthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_HealthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_health(inputs)
	if (locale === "es-419") return es_419_profile_why_health(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_health(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_health(inputs)
	if (locale === "de-DE") return de_de2_profile_why_health(inputs)
	if (locale === "it-IT") return it_it2_profile_why_health(inputs)
	return en_us2_profile_why_health(inputs)
});
export { profile_why_health as "profile.why_health" }